import React from "react";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { getShiftHours } from "utils/utils";
import { useTranslation } from "react-i18next";
import { RecruitGigForm } from "../sections/recruitGigForm.component";
import { ScheduleGigForm } from "../sections/scheduleGigForm.component";
import { HourlyRate } from "../hourlyRate/hourlyRate.component";
import { SectionCard } from "../createGigModal.styled";
import type {
  FormData,
  RecruitFormData,
  SelectedWorker,
  Tab,
} from "./gigFormModal.types";

type Props = {
  tab: Tab;
  canRecruit: boolean;
  isPublicRecruit: boolean;
  recruitFormData: RecruitFormData;
  setRecruitFormData: React.Dispatch<React.SetStateAction<RecruitFormData>>;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  formData: FormData;
  havePublicModule: boolean;
  haveTeamModule: boolean;
  selectedWorkers: SelectedWorker[];
  setSelectedWorkers: React.Dispatch<React.SetStateAction<SelectedWorker[]>>;
  handleRateChange: (min: number, max: number) => void;
  handlePaymentTypeChange: (
    paymentType: RecruitFormData["paymentType"],
  ) => void;
};

export const GigFormTabPanels: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    tab,
    canRecruit,
    isPublicRecruit,
    recruitFormData,
    setRecruitFormData,
    setFormData,
    formData,
    havePublicModule,
    haveTeamModule,
    selectedWorkers,
    setSelectedWorkers,
    handleRateChange,
    handlePaymentTypeChange,
  } = props;

  return (
    <>
      {tab === "Recruit" && canRecruit && (
        <SectionCard>
          <RecruitGigForm
            recruitFormData={recruitFormData}
            setRecruitFormData={setRecruitFormData}
            setFormData={setFormData}
            formData={formData}
            havePublicModule={havePublicModule}
            haveTeamModule={haveTeamModule}
          />
        </SectionCard>
      )}

      {isPublicRecruit && (
        <SectionCard>
          <Text typography="h5" color={ColorV2.Blue1}>
            {t("CreateShift.Payment")}
          </Text>
          <HourlyRate
            maxHourlyRate={recruitFormData.maxRate}
            minHourlyRate={recruitFormData.minRate}
            onChange={handleRateChange}
            onPaymentTypeChange={handlePaymentTypeChange}
            hours={getShiftHours(...formData.shifts)}
            shifts={formData.shifts}
            gigType={formData.type}
            paymentType={recruitFormData.paymentType}
          />
        </SectionCard>
      )}

      {tab === "Schedule" && (
        <SectionCard>
          <Text typography="h5" color={ColorV2.Blue1}>
            {t("CreateShift.ChooseWorker")}
          </Text>
          <ScheduleGigForm
            setSelectedWorkers={setSelectedWorkers}
            selectedWorkers={selectedWorkers}
            setShifts={(updater) =>
              setFormData((previousFormData) => ({
                ...previousFormData,
                shifts:
                  typeof updater === "function"
                    ? updater(previousFormData.shifts)
                    : updater,
              }))
            }
          />
        </SectionCard>
      )}
    </>
  );
};
